import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import React, { FC } from 'react';

interface CategoryListBlockProps {
  data: {
    title: string;
    url: string;
    icon: string;
  };
  closeMenu: () => void;
}

const CategoryListBlock: FC<CategoryListBlockProps> = ({ data, closeMenu }) => {
  const { title, url, icon } = data;

  return (
    <li className="megaMenu__categoryItem">
      <Link className="megaMenu__categoryLink" href={url} onClick={closeMenu}>
        <img className="megaMenu__categoryLink-icon" src={icon} alt="icon" aria-hidden="true" />
        {/* If you want to swap for SVGs use the below Icon component */}
        {/* <Icon className="megaMenu__categoryLink-icon" src={icon} aria-hidden="true"></Icon> */}
        <span className="megaMenu__categoryLink-text">{title}</span>
      </Link>
    </li>
  );
};

export default CategoryListBlock;
